import logo from "./logo.svg";
import "./App.css";
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  doc,
  setDoc,
  getDoc,
  getDocs,
  Timestamp,
  addDoc,
  limit,
  startAfter,
  startAt,
  endAt,
  endBefore,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import {
  useCollection,
  useDocumentData,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
// Import the functions you need from the SDKs you need

import { getAnalytics } from "firebase/analytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTruckField } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Container from "react-bootstrap/Container";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'
import Badge from 'react-bootstrap/Badge'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import * as moment from "moment";

import { useState, useEffect } from "react";
import AccordionBody from "react-bootstrap/esm/AccordionBody";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseApp);

const auth = getAuth(firebaseApp);

function Storymaker() {
  const [user, userLoading, userError] = useAuthState(auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  return userLoading ? (
    <Container centered>Loading</Container>
  ) : user ? (
    <div className="App">
      <StoryList user={user}></StoryList>
      {/* {error && <div>Error: {JSON.stringify(error)}</div>} */}
    </div>
  ) : (
    <div className="App">
      <Container>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
          />
        </Form.Group>
        <Button
          variant="primary"
          type="submit"
          onClick={() => signInWithEmailAndPassword(auth, email, password)}
        >
          Sign In
        </Button>
      </Container>
    </div>
  );
}

const StoryList = ({ user }) => {
  const [statusFilter, setStatusFilter] = useState(null);
  const [userStatusFilter, setUserStatusFilter] = useState(null);
  const [storyNameFilter, setStoryNameFilter] = useState(null);
  const [searchFilter, setSearchFilter] = useState(null);
  const [selectedStoryId, setSelectedStoryId] = useState(null);
  const [previousStoryId, setPreviousStoryId] = useState(null);
  const [config, setConfig] = useState(null);
  const [filterToLongTitle, setFilterToLongTitle] = useState(false);
  const [longTitleThreshold, setLongTitleThreshold] = useState(15);
  const [checkingForUpdatedLofties, setCheckingForUpdatedLofties] =
    useState(false);
  // let storyQuery =
  //   statusFilter && statusFilter != "all"
  //     ? where("status", "==", statusFilter)
  //     : where("status", "!=", "deleted");

  // const storyQuery =
  // let storyQuery = userStatusFilter
  //   ? where("status", "!=", "deleted").where(
  //       "user_status",
  //       "==",
  //       userStatusFilter
  //     )
  //   : where("status", "!=", "deleted");

  // console.log("storyQuery",  storyQuery);
  // let ordering = statusFilter
  //   ? orderBy("created_at", "desc")
  //   : orderBy("status", "asc");

  // const storiesRef = useCollection(
  //   collection(getFirestore(firebaseApp), "stories")

  const typeformRef = collection(getFirestore(firebaseApp), "typeforms");
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastDoc, setLastDoc] = useState(null);
  const [toQuery, setToQuery] = useState(null);
  const [numLoadStories, setNumLoadStories] = useState(35);
  const [previousStories, setPreviousStories] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [showOnHold, setShowOnHold] = useState(false)
  let paginatedStories;

  const storiesRef = collection(getFirestore(firebaseApp), "stories");
  // useEffect(()=>{
  //   loadInitialStories()
  // },[])

  //load paginated story

  const handleShowOnHold = ()=>{
    setShowOnHold(!showOnHold)
    if (showOnHold){
      setStatusFilter("on_hold")
    }else{
      setStatusFilter(null)
    }
  }

  useEffect(() => {
    setToQuery(storiesRef, orderBy("created_at", "desc"));
    const paginatedStories = query(
      storiesRef,
      orderBy("created_at", "desc"),
      limit(numLoadStories)
    );
    onSnapshot(paginatedStories, (querySnap) => {
      const firstStories = querySnap.docs.map((doc) => doc);
      setPageCount(1);
      setStories(firstStories);
      setPreviousStories([firstStories]);
      setLastDoc(querySnap.docs[querySnap.docs.length - 1]);
    });
    setLoading(false);
    // return()=>{
    //   unscubscribe()
    // }
  }, []);

  // const changeStoryCount = (num)=>{
  //   setNumLoadStories(num)
  //   // setToQuery(storiesRef, orderBy("created_at", "desc"))
  //   loadInitialStories()

  // }

  //set state toQuery based off filter/non filter
  const loadMoreStories = () => {
    let paginatedStories;
    if (!lastDoc) {
      paginatedStories = query(
        toQuery,
        orderBy("created_at", "desc"),
        limit(numLoadStories)
      );
    }
    paginatedStories = query(
      toQuery,
      startAfter(lastDoc),
      limit(numLoadStories)
    );
    onSnapshot(paginatedStories, (querySnap) => {
      const newStories = querySnap.docs.map((doc) => doc);
      setStories(newStories);
      setPreviousStories((stories) => [...stories, newStories]);
      setLastDoc(newStories[newStories.length - 1]);
      console.log(previousStories);
      console.log(stories);
    });
    setLoading(false);
    setPageCount((prevPageCount) => prevPageCount + 1);
    console.log(pageCount);
  };

  const goBack = () => {
    console.log("click");
    if (pageCount > 1) {
      setStories(previousStories[pageCount - 2]);
      //previous page for last doc, last doc two pages back
      const lastDocPrevPage =
        previousStories[pageCount - 2][
          previousStories[pageCount - 2].length - 1
        ];
      setLastDoc(lastDocPrevPage);
      setPageCount((prevPageCount) => prevPageCount - 1);
      console.log("page count", pageCount);
    }
  };

  //set query for filters

  const setFilters = () => {
    let fullQuery;
    if (userStatusFilter && userStatusFilter != "all") {
      fullQuery = query(
        storiesRef,
        where("user_status", "==", userStatusFilter),
        limit(numLoadStories)
      );
    } else if (statusFilter && statusFilter != "all") {
      fullQuery = query(
        storiesRef,
        where("status", "==", statusFilter),
        limit(numLoadStories)
      );
    } else {
      fullQuery = query(
        storiesRef,
        orderBy("created_at", "desc"),
        limit(numLoadStories)
      );
    }
    loadFilteredStories(fullQuery);
  };

  const loadFilteredStories = (fullQuery) => {
    setToQuery(fullQuery);
    onSnapshot(fullQuery, (querySnap) => {
      const filteredStories = querySnap.docs.map((doc) => doc);
      filteredStories.sort((b, a) => a.data().created_at - b.data().created_at);
      setStories(filteredStories);
      setPreviousStories([filteredStories]);
      setLastDoc(filteredStories[filteredStories.length - 1]);
    });
  };

  useEffect(() => {
    setFilters();
  }, [statusFilter, userStatusFilter]);

  // console.log("fullQuery", fullQuery);

  // const [stories, loading, error] = useCollection(
  //   query(
  //     collection(getFirestore(firebaseApp), "stories"),
  //     storyQuery
  //     // where("status", "!=", "deleted")

  //     // ordering
  //   ),
  //   {
  //     snapshotListenOptions: { includeMetadataChanges: true },
  //   }
  // );
  const [configData, configLoading, configError] = useCollection(
    collection(getFirestore(firebaseApp), "story-config"),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  const [storyNameObj, setStoryNameObj] = useState({});

  useEffect(() => {
    const typeformD = collection(getFirestore(firebaseApp), "typeforms");
    getDocs(typeformD)
      .then((querySnapshot) => {
        querySnapshot.forEach((docSnapshot) => {
          const typeformData = docSnapshot.data();
          const storyName = typeformData.story_name;
          const typeform = docSnapshot.id;
          // console.log(storyName)
          // console.log(typeform)
          storyNameObj[typeform] = storyName;
        });
        setStoryNameObj(storyNameObj);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [storyNameObj]);

  const checkForUpdatedLofties = async () => {
    console.log("checking here");
    const usersRef = collection(getFirestore(firebaseApp), "users");
    const storiesToCheck = stories?.docs.filter(
      (story) => story.data().user_status == "device_need_updates"
    );
    const storiesWithNewlyUpdatedDevices = [];
    storiesToCheck.forEach(async (story, i) => {
      const email = story.data().email;
      const q = query(usersRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);
      const user = querySnapshot.docs[0].data();
      // console.log("user", user);
      const devices = user.devices;

      for (let j = 0; j < devices.length; j++) {
        const device = devices[j];
        const deviceRef = doc(getFirestore(firebaseApp), "devices", device.id);
        const deviceSnap = await getDoc(deviceRef);
        const deviceVersion = deviceSnap?.data().state?.currentVer;
        // console.log(config.supported_versions, deviceVersion);
        if (config.supported_versions.includes(deviceVersion)) {
          storiesWithNewlyUpdatedDevices.push(story);
          const storyRef = doc(getFirestore(firebaseApp), "stories", story.id);
          setDoc(
            storyRef,
            { user_status: "completed_update" },
            { merge: true }
          );
        }
      }

      if (i == storiesToCheck.length - 1) {
        alert(
          `Of the ${storiesToCheck.length} stories to check, ${storiesWithNewlyUpdatedDevices.length} have been updated.`
        );
      }
    });

    // console.log("storiesToCheck", storiesToCheck);
  };



  const updatePresence = async (storyId, viewing = false) => {
    const storyRef = doc(getFirestore(firebaseApp), "stories", storyId);
    const viewers = storyRef?.viewers || {};
    console.log("updating presence");
    if (viewing) {
      viewers[user.email] = Timestamp.now();
    } else {
      delete viewers[user.email];
    }
    await setDoc(storyRef, { viewers: viewers }, { merge: true });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    const id = params.get("id"); // 123
    console.log("id", id);
    if (id) {
      setSelectedStoryId(id);
    }
  }, []);

  useEffect(() => {
    if (configData && configData.docs && configData.docs[0]) {
      setConfig(configData.docs[0].data());
    }
  }, [configData]);

  useEffect(() => {
    if (selectedStoryId) {
      window.history.pushState(null, null, `?id=${selectedStoryId}`);
      updatePresence(selectedStoryId, true);
    } else {
      window.history.pushState(null, null, "/");
      if (previousStoryId) {
        updatePresence(previousStoryId, false);
      }
    }
  }, [selectedStoryId]);

  const getActiveViewers = (story) => {
    const viewers = story?.data()?.viewers || {};
    const activeViewers = [];
    Object.keys(viewers).map((key) => {
      const date = new Date(viewers[key]?.seconds * 1000);
      const now = new Date();
      const diff = now.getTime() - date.getTime();
      const diffMins = Math.round(diff / 60000);
      if (diffMins < 5) {
        // extract name from begining of email
        const name = key.split("@")[0];
        activeViewers.push(name);
      }
    });
    return activeViewers;
  };
  function getAudioDuration(url) {
    return new Promise((resolve, reject) => {
      const audio = new Audio();

      // This event will be triggered when the metadata has been loaded
      audio.addEventListener("loadedmetadata", function () {
        resolve(audio.duration);
      });

      // Error handling
      audio.addEventListener("error", function () {
        reject(new Error("Error loading audio file."));
      });

      // Assign the URL to the audio element
      audio.src = url;
    });
  }

  const albumMap = {
    soundbaths: "Sound Baths",
    classics: "Classics",
    breathwork: "Breathwork",
    Handpicked: "Horoscopes",
    phoebe: "Phive",
    blackzen: "Daily Meditations",
    noise: "White Noises",
    nature: "Nature Sounds",
    movement: "Movement",
    pattern: "Pattern",
    sleepstories: "Sleep Stories",
    snoozecast: "Snoozecast",
    classics: "Classics",
    affirmations: "Affirmations"
  };

  const audioPrefix = "https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/";

  const addClockPlaylist = async () => {
    config?.default_playlist?.playlists?.map(async (playlist) => {
      // console.log(playlist.tracks)
      let albumName = playlist.tracks[0]?.Path.split("/")[0];

      const albumCollection = collection(
        getFirestore(firebaseApp),
        "audio-album"
      );

      console.log(albumName);
      // return
      if (albumName == "affirmations") {
        // const q = query(
        //   albumCollection,
        //   where("title", "==", albumMap[albumName])
        // );
        // const querySnapshot = await getDocs(q);
        // const album = querySnapshot.docs[0].data();
        // console.log(querySnapshot.docs[0].id);
        // const albumRef = doc(
        //   getFirestore(firebaseApp),
        //   "audio-album",
        //   querySnapshot.docs[0].id
        // );
        // const albumSnap = await getDoc(albumRef);
        // // const deviceSnap = await getDoc(deviceRef);
        // // const albumRef = doc(
        // //   getFirestore(firebaseApp),
        // //   "audio-album",
        // //   querySnapshot.docs[0].id
        // // );
        // console.log(querySnapshot.docs[0]);
        // console.log(albumSnap);

        const trackRefs = [];

        let albumRef

        for (let i = 0; i < playlist.tracks.length; i++) {
          // return
          const track = playlist.tracks[i];

          // if (track.Name.toLowerCase().includes("noise")) {
          //   albumName = "noise";
          //   continue; 
          // } else {
          //   albumName = "movement";
            
          // }
          const q = query(
            albumCollection,
            where("title", "==", albumMap[albumName])
          );
          const querySnapshot = await getDocs(q);
          const album = querySnapshot.docs[0].data();
          console.log(querySnapshot.docs[0].id);
          albumRef = doc(
            getFirestore(firebaseApp),
            "audio-album",
            querySnapshot.docs[0].id
          );
          const albumSnap = await getDoc(albumRef);
          // const deviceSnap = await getDoc(deviceRef);
          // const albumRef = doc(
          //   getFirestore(firebaseApp),
          //   "audio-album",
          //   querySnapshot.docs[0].id
          // );
          console.log(querySnapshot.docs[0]);
          console.log(albumSnap);

          // console.log(track)

          const duration = await getAudioDuration(
            `${audioPrefix}${track.Path}`
          );
          console.log("duration", duration);
          const newTrack = {
            albumRef: albumRef,
            looping: false,
            length: duration,
            title: track.Name,
            source: `${audioPrefix}${track.Path}`,
            index: i,
          };
          console.log(newTrack);
          // // continue
          const trackRes = await addDoc(
            collection(getFirestore(firebaseApp), "audio-tracks"),
            newTrack
          );
          trackRefs.push({trackRef: trackRes})
          // console.log(trackRes.id);
        }
        console.log("albumRef", albumRef)
        setDoc(albumRef, { tracks: trackRefs }, { merge: true });
      }
    });
  };


 

  const [onHoldStories, setOnHoldStories] = useState([])

  useEffect(()=>{
    const storiesRef = collection(getFirestore(firebaseApp), "stories")
    // const onHoldQuery = query(storiesRef, where("status", "==", "on_hold"))
    const fullQuery = query(storiesRef, where("status", "==", "on_hold"),
    )
    setOnHoldStories([...onHoldStories, fullQuery])
  },[])





  

  return (
    <div>
      <Spacer height={12} />
      <Spacer height={12} />
      <h6>Storymaker</h6>
      <Container style={{ display: "flex", justifyContent: "flex-start" }}>
        <Button variant="outline-info" size="sm" onClick={() => goBack()}>
          {"<< previous page"}
        </Button>
        {/* <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        Number of Stories
      </Dropdown.Toggle>

      <Dropdown.Menu>
      <Dropdown.Item onClick={()=> setNumLoadStories(20)}>20</Dropdown.Item>
        <Dropdown.Item onClick={()=> setNumLoadStories(30)}>30</Dropdown.Item>
        <Dropdown.Item onClick={()=> setNumLoadStories(40)}>40</Dropdown.Item>
        <Dropdown.Item onClick={()=> setNumLoadStories(50)}>50</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown> */}
        <Spacer width={12} />
        <Button
          variant="outline-info"
          size="sm"
          onClick={() => loadMoreStories()}
        >
          {"next page >>"}
        </Button>
        <Spacer height={12} />
      </Container>
      <br></br>
      <div></div>
      <Container style={{ display: "flex" }}>
        <InputGroup className="mb-3">
          <InputGroup.Text>Search and Filter</InputGroup.Text>
          <Form.Select
            aria-label="Default select example"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value={"all"}>Filter by status</option>
            {config?.story_statuses?.map((status) => (
              <option value={status}>{status}</option>
            ))}
          </Form.Select>
          <Form.Select
            aria-label="Default select example"
            value={userStatusFilter}
            onChange={(e) => setUserStatusFilter(e.target.value)}
          >
            <option value={"all"}>Filter by user status</option>
            {config?.user_status?.map((status) => (
              <option value={status}>{status}</option>
            ))}
          </Form.Select>
          <Form.Select
            aria-label="Default select example"
            value={storyNameFilter}
            onChange={(e) => setStoryNameFilter(e.target.value)}
            // onChange={(e) => setStoryNameFilter(e.target.value)}
          >
            <option value={"all"}>Filter Story Name</option>
            {config?.story_title?.map((title) => (
              <option value={title}>{title}</option>
            ))}
          </Form.Select>

          <Button variant="primary" onClick={() => checkForUpdatedLofties()}>
            Check for updated lofties
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setFilterToLongTitle(!filterToLongTitle);
            }}
          >
            {filterToLongTitle ? "Show all" : "Show only long titles"}
          </Button>
          <Button variant="primary" onClick={()=> handleShowOnHold()}>
          <h7>
            Number of On Hold Stories:<Badge variant = "outline-primary">{onHoldStories.length}</Badge>
          </h7>
          </Button>
        </InputGroup>

      </Container>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>viewing</th>
            <th>created_at</th>
            <th>id</th>
            <th>email</th>
            <th>title</th>
            <th>status</th>
            <th>user_status</th>
            {/* <th>sent_time</th> */}
            <th>story_name</th>
          </tr>
        </thead>
        <tbody>
          {stories
            ?.filter((story) => {
              if (filterToLongTitle) {
                if (story.data().story_title?.length > 30) {
                  return story;
                }
              } else {
                return story;
              }
            })
            .map((story) => {
              const date = new Date(story.data().created_at?.seconds * 1000);
              const typeformId = story.data().form_id;

              // const storyTime = story.data().sent_time
              // const sendTime = storyTime.toMillis()

              return (
                <tr
                  style={{ cursor: "pointer" }}
                  key={story.id}
                  onClick={() => {
                    setSelectedStoryId(story.id);
                  }}
                >
                  <td>{getActiveViewers(story)}</td>
                  <td>{`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`}</td>
                  <td>{story.id}</td>
                  <td>{story.data().email}</td>
                  <td>{story.data().story_title}</td>
                  <td>{story.data().status}</td>
                  <td>{story.data().user_status}</td>
                  {/* <td>{story.data().sent_time}</td> */}
                  <td>{storyNameObj[story.data().form_id]}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {loading && <div>Loading...</div>}
      {selectedStoryId && (
        <StoryEditor
          selectedStoryId={selectedStoryId}
          setSelectedStoryId={setSelectedStoryId}
          setPreviousStoryId={setPreviousStoryId}
          config={config}
          updatePresence={updatePresence}
        ></StoryEditor>
      )}
      <Container style={{ display: "flex", justifyContent: "flex-start" }}>
        <Button variant="outline-info" size="sm" onClick={() => goBack()}>
          {"<< previous page"}
        </Button>
        <Spacer width={12} />
        <Button
          variant="outline-info"
          size="sm"
          onClick={() => loadMoreStories()}
        >
          {"next page >>"}
        </Button>
        <Spacer height={12} />
        <div></div>
      </Container>
      {/* {checkingForUpdatedLofties && (
        <Modal
        show={checkingForUpdatedLofties}
        onHide={() => checkingForUpdatedLofties(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          
        </Modal.Header>
  
        <Modal.Body>
          <div style={{ display: "flex", justifyContent: "center" }}>

            </div>
          </Modal.Body>
          </Modal>
      )} */}
    </div>
  );
};

// const typeforms = collection(getFirestore(firebaseApp), "typeforms")

// get(/databases/$(database)/documents/users/$(request.auth.uid)).isAdmin;
const StoryEditor = ({
  selectedStoryId,
  setSelectedStoryId,
  setPreviousStoryId,
  config,
  updatePresence,
}) => {
  const usersRef = collection(getFirestore(firebaseApp), "users");
  // const [lofties, setLofties] = useState([]);
  const [user, setUser] = useState(null);
  const [storyLocalData, setStoryLocalData] = useState(null);
  const [selectedStory, loadingStory, errorStory, reload] = useDocumentData(
    doc(getFirestore(firebaseApp), "stories", selectedStoryId)
  );
  const [userRecords, loading, error] = useCollection(
    query(usersRef, where("email", "==", selectedStory?.email || "")),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  useEffect(() => {
    if (userRecords?.docs[0]?.data()) {
      console.log("this", {
        ...{ id: userRecords?.docs[0]?.id },
        ...userRecords?.docs[0]?.data(),
      });
      setUser({
        ...{ id: userRecords?.docs[0]?.id },
        ...userRecords?.docs[0]?.data(),
      });
    }
  }, [userRecords]);

  useEffect(() => {
    if (selectedStory) {
      setStoryLocalData(selectedStory);
    }
  }, [selectedStory]);

  const updateStory = async (data) => {
    const storyRef = doc(getFirestore(firebaseApp), "stories", selectedStoryId);
    setDoc(storyRef, data, { merge: true });
    updatePresence(selectedStoryId, true);
  };

  const updateUser = async (data) => {
    const userRef = doc(getFirestore(firebaseApp), "users", user.id);
    setDoc(userRef, data, { merge: true });
  };

  const addToUserStories = async () => {
    const userRef = doc(getFirestore(firebaseApp), "users", user.id);
    const userExistingStories = user?.stories || [];
    console.log("existing 1", userExistingStories);
    let updated = false;
    userExistingStories.map((story) => {
      if (story.id == selectedStoryId) {
        story.path = selectedStory.optimized_story_path;
        story.title = selectedStory.story_title;
        updated = true;
      }
    });
    if (!updated) {
      userExistingStories.push({
        id: selectedStoryId,
        path: selectedStory.optimized_story_path,
        title: selectedStory.story_title,
      });
    }
    // console.log("existing", userExistingStories);
    setDoc(userRef, { stories: userExistingStories }, { merge: true });
  };

  const sendPlaylist = async () => {
    const sendTime = Timestamp.now();

    let playlistObject =
      JSON.parse(JSON.stringify(config?.default_playlist)) || [];
    console.log("playlist", playlistObject);
    // playlistObject.playlists = playlistObject?.playlists?.map((item) => {
    //   return item.tracks;
    // });
    let longStoryTitle = false;
    playlistObject?.playlists?.map((playlist) => {
      if (playlist?.tracks?.length > 0) {
        const track = playlist.tracks?.[0];
        if (track["Path"].indexOf("storymaker") > -1) {
          user.stories.map((story) => {
            if (story.title.length > 30) {
              alert("long title warning! Aborting send");
              longStoryTitle = true;
              return;
            } else {
              playlist.tracks.push({
                Name: story.title,
                Path: story.path,
                sName: story.title,
                isEssential: 0,
              });
            }
          });
        }
      }
    });

    const playlistId = Math.floor(Date.now() / 1000);
    playlistObject["id"] = playlistId;

    const updateDetails = {
      event_type: "send_new_story",
      story_id: selectedStoryId,
      track_path: `storymaker/${selectedStoryId}`,
    };

    playlistObject["update_details"] = updateDetails;

    console.log("playlist after", playlistObject);
    // if (longStoryTitle) {
    //   return;
    // }
    user?.devices?.map(async (device) => {
      const deviceRef = doc(getFirestore(firebaseApp), "devices", device.id);
      const deviceSnap = await getDoc(deviceRef);
      const deviceVersion = deviceSnap?.data().state?.currentVer;
      console.log(config.supported_versions, deviceVersion);
      if (config.supported_versions.includes(deviceVersion)) {
        const deviceDetailsRef = doc(
          getFirestore(firebaseApp),
          "device-details",
          device.id
        );

        setDoc(
          deviceDetailsRef,
          { pending_playlist: playlistObject },
          { merge: true }
        );

        alert(`Playlist sent to Loftie ${device.id}`);
      } else {
        alert(`Playlist not sent to unsupported Loftie ${device.id}`);
      }
    });
  };
  console.log("selectedStory", selectedStory);
  const deleteStory = async (user, story) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this story?"
    );
    if (confirmed) {
      const userRef = doc(getFirestore(firebaseApp), "users", user.id);
      const userExistingStories = user?.stories || [];
      console.log("existing 1", userExistingStories);
      console.log("story", story);
      console.log("detete");
      const newStories = userExistingStories.filter(
        (item) => item.id !== story.id
      );
      console.log("newStories", newStories);
      setDoc(userRef, { stories: newStories }, { merge: true });
    }
    //should we invoke sendPlaylist here to send the playlist w/o that story?
  };
  // useEffect(() => {
  //   console.log(userRecord, error);
  // }, [userRecord, error]);

  const resendStory = (story)=>{
    let resendCount = story?.on_hold_resend_count || 0
    resendCount ++
    updateStory({'status':'chatgpt_in_progress', 'on_hold_resend_count': resendCount})
  }

  return (
    <Modal
      show={selectedStory}
      onHide={() => {
        setPreviousStoryId(selectedStoryId);
        setSelectedStoryId(null);
      }}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: "#888" }}>
              <a
                href={`https://console.firebase.google.com/u/0/project/loftie-4f472/firestore/data/~2Fstories~2F${selectedStoryId}`}
                target="_blank"
              >
                {selectedStoryId}
              </a>
            </span>
            <Spacer width={20} />
            <a
              href={`/user?email=${user?.email}`}
              target="_blank"
            > 
              {selectedStory?.email}
            </a>
            <Spacer width={20} />
            <Form.Select
              aria-label="Update status"
              value={selectedStory?.status}
              onChange={(e) => updateStory({ status: e.target.value })}
            >
              {config?.story_statuses?.map((status) => (
                <option value={status}>{status}</option>
              ))}
            </Form.Select>
            <Form.Select
              aria-label="Update status"
              value={selectedStory?.user_status}
              onChange={(e) => updateStory({ user_status: e.target.value })}
            >
              {config?.user_status?.map((user_status) => (
                <option value={user_status}>{user_status}</option>
              ))}
            </Form.Select>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Container >
      {(selectedStory?.status === "on_hold" || selectedStory?.status === "exceeded_max_resends") && (
      <Row className="justify-content-end">
      <Col sm={2} >
        <Form.Select
          aria-label="Update status"
          value={selectedStory?.on_hold}
          onChange={(e) => updateStory({ on_hold_reason: e.target.value })}
        >
          {config?.on_hold_reasons?.map((on_hold_reason) => (
            <option key={on_hold_reason} value={on_hold_reason}>
              {on_hold_reason}
            </option>
          ))}
        </Form.Select>
        </Col>
        <></>
        <Col sm={2}>
            <h4><Button variant="outline-primary">
              Resent {selectedStory?.on_hold_resend_count || 0} Times
            </Button></h4>
        </Col>
        <></>
        <Col sm={2}>
          <h4><Button variant="outline-primary" onClick = {()=>resendStory(selectedStory)}
            >
            Resend Story
          </Button></h4>
        </Col>
        {storyLocalData?.chatgpt_output && (
            <Col sm={3}>
            <Button variant="outline-primary">
                  Character count:{" "}
                  <span
                    style={{
                      color:
                        storyLocalData?.chatgpt_output?.length >= 5000
                          ? "red"
                          : "green",
                    }}
                  >
                    {storyLocalData?.chatgpt_output?.length}
                  </span>
                  </Button>
        </Col>
        )}
    {/* <Spacer width={50} /> */}
    </Row>
          )}
          </Container>
      <Modal.Body>
        <Accordion defaultActiveKey="0" flush alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>0. User / Loftie Information</Accordion.Header>
            <Accordion.Body>
              {user ? (
                <>
                  <h5>Lofties</h5>
                  {user?.devices?.length > 0 ? (
                    <>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>firmware version</th>
                            <th>Links</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user?.devices?.map((device) => (
                            <LoftieInfo loftieId={device.id} />
                          ))}
                        </tbody>
                      </Table>
                    </>
                  ) : (
                    <p>No Lofties found</p>
                  )}
                  <h5>Stories</h5>
                  {user?.stories?.length > 0 ? (
                    <>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            {/* <th>id</th> */}
                            <th>title</th>
                            <th>path</th>
                            <th>play</th>
                            <th>actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user?.stories?.map((story) => (
                            <tr key={story.id}>
                              {/* <td>{story.id}</td> */}
                              <td>{story.title}</td>
                              <td>
                                <a
                                  href={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${story.path}`}
                                >
                                  {story.path}
                                </a>
                              </td>
                              <td>
                                <audio
                                  controls
                                  src={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${story.path}`}
                                />
                              </td>
                              <td>
                                <FontAwesomeIcon
                                  onClick={() => deleteStory(user, story)}
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  ) : (
                    <p>No stories yet</p>
                  )}

                  <Button
                    variant="outline-success"
                    onClick={() => {
                      sendPlaylist();
                    }}
                  >
                    Send playlist to eligible Lofties
                  </Button>
                </>
              ) : (
                <p>No user with this email found</p>
              )}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>1. Typeform input</Accordion.Header>
            <Accordion.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedStory?.questions_and_answers?.map((obj) => (
                    <tr key={obj.question}>
                      <td>{obj.question}</td>
                      <td>{obj.answer}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <br></br>
              <Button
                variant="outline-primary"
                onClick={() => {
                  updateStory({ status: "regenerate_prompt" });
                }}
              >
                Regenerate Chatgpt prompt
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>2. Chatgpt Prompt</Accordion.Header>
            <Accordion.Body>
              <InputGroup>
                <InputGroup.Text>Maxim</InputGroup.Text>
                <Form.Control
                  as="textarea"
                  aria-label="With textarea"
                  onChange={(e) =>
                    setStoryLocalData({
                      ...storyLocalData,
                      chatgpt_maxim: e.target.value,
                    })
                  }
                  onBlur={(e) => {
                    updateStory({ chatgpt_maxim: e.target.value });
                  }}
                  value={storyLocalData?.chatgpt_maxim}
                  style={{ height: 300 }}
                />
              </InputGroup>
              <InputGroup>
                <InputGroup.Text>Prompt</InputGroup.Text>
                <Form.Control
                  as="textarea"
                  aria-label="With textarea"
                  onChange={(e) =>
                    setStoryLocalData({
                      ...storyLocalData,
                      chatgpt_prompt: e.target.value,
                    })
                  }
                  onBlur={(e) => {
                    updateStory({ chatgpt_prompt: e.target.value });
                  }}
                  value={storyLocalData?.chatgpt_prompt}
                  style={{ height: 300 }}
                />
              </InputGroup>
              <br></br>
              <Button
                variant="outline-primary"
                onClick={() => {
                  updateStory({ status: "chatgpt_in_progress" });
                }}
              >
                Send to Chatgpt
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>3. Chatgpt Output</Accordion.Header>
            <Accordion.Body>
              <InputGroup>
                <InputGroup.Text>Story Title</InputGroup.Text>

                <Form.Control
                  type="text"
                  value={storyLocalData?.story_title}
                  onChange={(e) =>
                    setStoryLocalData({
                      ...storyLocalData,
                      story_title: e.target.value,
                    })
                  }
                  onBlur={(e) => updateStory({ story_title: e.target.value })}
                  placeholder="Story Title"
                />
              </InputGroup>
              <InputGroup>
                <InputGroup.Text>Output</InputGroup.Text>
                <Form.Control
                  as="textarea"
                  aria-label="With textarea"
                  value={storyLocalData?.chatgpt_output}
                  onChange={(e) =>
                    setStoryLocalData({
                      ...storyLocalData,
                      chatgpt_output: e.target.value,
                    })
                  }
                  onBlur={(e) => {
                    updateStory({ chatgpt_output: e.target.value });
                  }}
                  style={{ height: 200 }}
                />
              </InputGroup>
              <br></br>
              {storyLocalData?.chatgpt_output && (
                <p>
                  Character count:{" "}
                  <span
                    style={{
                      color:
                        storyLocalData?.chatgpt_output?.length >= 5000
                          ? "red"
                          : "green",
                    }}
                  >
                    {storyLocalData?.chatgpt_output?.length}
                  </span>{" "}
                  (max 5000)
                </p>
              )}
              <Button
                variant="outline-primary"
                onClick={() => {
                  updateStory({ status: "ready_for_tts" });
                }}
              >
                Send to Voice Generator
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>4.Optimized Output</Accordion.Header>
            <Accordion.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Path</th>
                    <th>Play</th>
                  </tr>
                </thead>
                <tbody>
                  <tr centered>
                    <td>{storyLocalData?.story_title}</td>
                    <td>
                      <a
                        href={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${storyLocalData?.optimized_story_path}`}
                      >
                        {storyLocalData?.optimized_story_path}
                      </a>
                    </td>
                    <td>
                      <audio
                        controls
                        src={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${storyLocalData?.optimized_story_path}`}
                      ></audio>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Button
                variant="outline-primary"
                onClick={() => {
                  addToUserStories();
                }}
              >
                Add to user's stories
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {/* table to hold questions and answers */}

        {/* <p>{selectedStory?.data().story_message}</p> */}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => setSelectedStoryId(null)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const LoftieInfo = ({ loftieId }) => {
  const [snapshot, loading, error, reload] = useDocumentDataOnce(
    doc(getFirestore(firebaseApp), "devices", loftieId)
  );
  return (
    <tr key={loftieId}>
      <td> {loftieId}</td>
      <td>{snapshot?.state?.currentVer}</td>
      <td>
        <a href={`/loftie?id=${loftieId}`} target="_blank">
          device details
        </a>
        &nbsp;
        <a
          href={`https://console.firebase.google.com/u/0/project/loftie-4f472/firestore/data/~2Fdevice-configs~2F${loftieId}`}
          target="_blank"
        >
          config
        </a>
      </td>
    </tr>
  );
};

const Spacer = ({ width, height }) => {
  return <div style={{ width: width || 1, height: height || 1 }}></div>;
};

export default Storymaker;
